import React from 'react'
import {REPORT_COPYRIGHT_NOTICE} from '../data/legal'

const ReportFooter: React.FC = () => (
  <footer id="methodology" className="site">
    <div className="wrap">
      <div className="row">
        <div>
          <h5>Methodology</h5>
          <p>
            Anonymised card transaction data from{' '}
            <strong style={{color: 'rgba(255,255,255,0.9)', fontWeight: 500}}>European companies</strong>. €302M across
            20,088 vendors, January 2024 – May 2026. 19 software categories. All figures in EUR. YoY comparisons are
            like-for-like (Jan–May 2025 vs Jan–May 2026). No individual company data disclosed.
          </p>
        </div>
        <div>
          <h5>Powered by Moss</h5>
          <div className="powered">
            Spend management for European businesses.
            <div style={{marginTop: 14}}>
              <a href="https://getmoss.com">getmoss.com →</a>
            </div>
          </div>
        </div>
      </div>
      <div className="legal-bar">
        <p>{REPORT_COPYRIGHT_NOTICE}</p>
      </div>
    </div>
  </footer>
)

export default ReportFooter
